import { create } from 'zustand';
import {
  Project,
  Header,
  EndProject,
  OnGoingProject,
  getHeader,
  getProjectList,
} from '@/apis';

type State = {
  header?: Header;
  list: Project[];
  endList: EndProject[];
  onGoingList: OnGoingProject[];
  activityLoading: boolean,
  historyLoading: boolean,
  total: number;
  pageSize: number;
  current: number;
  loading: boolean;
};

interface PaginationParams {
  current: number;
  pageSize: number;
}

type Action = {
  setList: (newList: State['list']) => void;
  setHeader: (newList: State['header']) => void;
  fetchHeader: () => Promise<void>;
  fetchData: (params: PaginationParams) => Promise<void>;
  setOnGoingList: (newList: State['onGoingList']) => void;
  setEndList: (newList: State['endList']) => void;
  setActivityLoading: (loading: State['activityLoading']) => void;
  setHistoryLoading: (loading: State['historyLoading']) => void;
};

export const useList = create<State & Action>((set) => ({
  header: undefined,
  list: [],
  endList: [],
  onGoingList: [],
  total: 0,
  pageSize: 10,
  current: 1,
  loading: true,
  activityLoading: true,
  historyLoading: true,
  setList: (newList) => set(() => ({ list: newList })),
  setHeader: (newHeader) => set(() => ({ header: newHeader })),
  fetchHeader: async () => {
    try {
      const { result = undefined } = (await getHeader()) || {};
      set(() => ({ header: result }));
    } catch (e) {
      console.error(e);
    }
  },
  fetchData: async ({ current, pageSize }) => {
    try {
      set(() => ({ loading: true }));
      const { result } = await getProjectList({ pageNo: current, pageSize });
      set(() => ({
        list: result?.list || [],
        total: result?.total || 0,
        pageSize: result?.pageSize || 0,
        current: result?.current || 0,
        loading: false,
      }));
    } catch (e) {
      console.log(e);
    }
  },
  setActivityLoading: (loading) => set(() => ({ activityLoading: loading })),
  setHistoryLoading: (loading) => set(() => ({ historyLoading: loading })),
  setOnGoingList: (newList) => set(() => ({ onGoingList: newList })),
  setEndList: (newList) => set(() => ({ endList: newList })),
}));
